import betch from '@/lib/bouqsFetch';
import {
  Category as CategoryInterface,
  Error as ErrorInterface,
} from '@/interfaces';
import { getValidQs, allowlistedQueryParams } from '@/utils/urlQueryParams';
import {
  CategoryType,
  FetchCategoriesListPayload,
  GetCategoryListPayload,
  FetchCategoryPayload,
} from '@/lib/categories.d';
import { QueryParams, Slug } from '@/lib/content/content.d';

const CATALOG_ENDPOINT = '/catalog_categories';

export async function fetchCategoriesList(): Promise<FetchCategoriesListPayload> {
  // Call an external API endpoint to fetch list of categories
  // This list is how we determine which catalog pages to build/render
  // https://nextjs.org/docs/routing/dynamic-routes
  try {
    const res = await betch.get(`${CATALOG_ENDPOINT}`);
    return res.data;
  } catch (error) {
    console.error('there was an error fetching category lists', error);
    throw error;
  }
}

export async function fetchCategory(
  categoryType: CategoryType,
  slug: Slug,
  qs = ''
): Promise<FetchCategoryPayload> {
  // Fetch a single category from storefront RoR API
  try {
    const allowlistedQs = getValidQs(qs, allowlistedQueryParams.category);
    const { data, statusText } = await betch.get(
      `${CATALOG_ENDPOINT}/${categoryType}/${slug}?${allowlistedQs}`
    );
    if (data) {
      return data as CategoryInterface;
    } else {
      console.error('category response not ok', statusText);
      console.error(
        '[fetchCategory] request url',
        `${CATALOG_ENDPOINT}/${categoryType}/${slug}?${qs}`
      );
      console.error('[fetchCategory] error', data);
      return { error: statusText } as ErrorInterface;
    }
  } catch (error) {
    console.error('there was an error fetching the category', error);
    throw error;
  }
}

export async function getCategoriesList(): Promise<GetCategoryListPayload[]> {
  return await fetchCategoriesList();
}

// this one is for generating static category pages
export async function getCategoryData(
  categoryType: CategoryType,
  slug: Slug,
  additionalQs?: QueryParams
): Promise<FetchCategoryPayload> {
  // Fetch all result pages, expecting this to be less than 10 pages
  let category: CategoryInterface = null;
  const pageNumber = 1;

  const qs = `page=${pageNumber}${additionalQs ? `&${additionalQs}` : ''}`;

  const page: FetchCategoryPayload = await fetchCategory(
    categoryType,
    slug,
    qs
  );

  if ((page as ErrorInterface).error) {
    // if one page fails, return the error immediately
    return page;
  }

  if (!(page as CategoryInterface).products) {
    (page as CategoryInterface).products = [];
  }

  category = page as CategoryInterface;

  return category;
}
